import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/license',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/view/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];

export default routes;
